import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NotificariService {
    private basePath = environment.interop.basePath;

    public downloadEmailUrl = this.basePath + environment.interop.indoc.notificari.email.downloadEmail;
    private resendEmailUrl = this.basePath + environment.interop.indoc.notificari.email.resendEmail;
    private printNotificariEmailUrl = this.basePath + environment.interop.indoc.notificari.email.printNotificari;

    constructor(private http: HttpClient) { }

    resendEmail(id: number) {
        return this.http.post(this.resendEmailUrl + id, {});
    }

    printNotificariEmail(payload: any) {
        return this.http.post(this.printNotificariEmailUrl, payload, { responseType: 'blob' as 'json' });
    }
}
